import type { RefreshAuthResult } from "@/util/auth/refreshAuthResult";

/** リフレッシュ結果に応じてセッション破棄（再ログイン誘導）するか */
export function shouldClearSessionOnRefreshFailure(
  result: RefreshAuthResult,
): boolean {
  return result.status === "auth_failed";
}

/** リフレッシュ成功時だけリトライする */
export function canRetryOriginalRequest(result: RefreshAuthResult): boolean {
  return result.status === "success";
}

/**
 * 失敗リクエストのBearerと、いまメモリにあるトークンが違うとき。
 * すでにリフレッシュ済みの古い応答なので、再リフレッシュせず新トークンで送り直す。
 */
export function shouldRetryWithMemoryToken(params: {
  authorizationHeader: string | undefined;
  accessTokenInMemory: string | null | undefined;
}): params is {
  authorizationHeader: string | undefined;
  accessTokenInMemory: string;
} {
  const { authorizationHeader, accessTokenInMemory } = params;
  if (!accessTokenInMemory) return false;
  const failedBearer = authorizationHeader?.trim();
  const memoryBearer = `Bearer ${accessTokenInMemory}`;
  return failedBearer !== memoryBearer;
}
